import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersApi } from '../api/users.api';
import { IUser } from '../models/users';
import { ServiceBase } from './service.base';
import { IUserDTO } from '../dto/user-dto';

@Injectable()
export class UsersService extends ServiceBase<IUser, IUserDTO> {

  constructor(private api: UsersApi) {
    super(api);
  }

  getCurrentUser(): Observable<IUserDTO> {
    return this.api.getCurrent();
  }

  updateCurrent(user: any): Observable<IUserDTO> {
    return this.api.updateCurrent(user);
  }
}


